import { SET_FEEDBACK_STATUSES } from '@/store/mutation_types'

export default {
  SET_FEEDBACK_STATUSES(state, value) {
    state.feedbackStatuses = value
  },
  [SET_FEEDBACK_STATUSES](state, value) {
    state.feedbackStatuses = value
  },
}
